import React from 'react';
import { NewCaseView } from 'pages/components';

const ARContactCasesNewView = (props) => (
  <NewCaseView {...props} />
);

export default ARContactCasesNewView;
